import React from 'react';
import { Link, UserPlus, Clock, CheckCircle, XCircle, Loader2 } from 'lucide-react';

export const ConnectionStatsCards = ({ connectionStats }) => {
  if (!connectionStats) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      <div className="bg-white p-6 rounded-lg border border-zinc-200">
        <div className="flex items-center gap-2 mb-2">
          <Link className="h-5 w-5 text-zinc-600" />
          <p className="text-sm text-zinc-600">Ümumi</p>
        </div>
        <p className="text-3xl font-bold text-zinc-900">{connectionStats.total || 0}</p>
      </div>
      <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-200">
        <div className="flex items-center gap-2 mb-2">
          <Clock className="h-5 w-5 text-yellow-600" />
          <p className="text-sm text-yellow-800">Gözləyən</p>
        </div>
        <p className="text-3xl font-bold text-yellow-900">{connectionStats.pending || 0}</p>
      </div>
      <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
        <div className="flex items-center gap-2 mb-2">
          <Loader2 className="h-5 w-5 text-blue-600" />
          <p className="text-sm text-blue-800">İcrada</p>
        </div>
        <p className="text-3xl font-bold text-blue-900">{connectionStats.in_progress || 0}</p>
      </div>
      <div className="bg-green-50 p-6 rounded-lg border border-green-200">
        <div className="flex items-center gap-2 mb-2">
          <CheckCircle className="h-5 w-5 text-green-600" />
          <p className="text-sm text-green-800">Tamamlanmış</p>
        </div>
        <p className="text-3xl font-bold text-green-900">{connectionStats.completed || 0}</p>
      </div>
    </div>
  );
};

export const ConnectionStatusBreakdown = ({ connectionStats }) => {
  if (!connectionStats?.by_status) return null;

  const statusLabels = {
    new: 'Yeni',
    reviewing: 'Yoxlanılır',
    planned: 'Planlanıb',
    in_progress: 'İcrada',
    completed: 'Tamamlanıb',
    cancelled: 'Ləğv edilib',
    rejected: 'İmtina edilib',
    not_connected: 'Qoşulmadı'
  };

  const statusColors = {
    new: 'text-blue-600',
    reviewing: 'text-yellow-600',
    planned: 'text-purple-600',
    in_progress: 'text-orange-600',
    completed: 'text-green-600',
    cancelled: 'text-red-600',
    rejected: 'text-red-600',
    not_connected: 'text-gray-600'
  };

  return (
    <div className="bg-white p-6 rounded-lg border border-zinc-200">
      <h3 className="text-lg font-bold mb-4 text-zinc-900">Qoşulma Statusları</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {Object.entries(connectionStats.by_status).map(([status, count]) => (
          <div key={status}>
            <p className="text-sm text-zinc-600">{statusLabels[status] || status}</p>
            <p className={`text-2xl font-bold ${statusColors[status] || 'text-zinc-900'}`}>{count}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export const ConnectionByGroupBreakdown = ({ connectionStats }) => {
  if (!connectionStats?.by_group || Object.keys(connectionStats.by_group).length === 0) return null;

  return (
    <div className="bg-white p-6 rounded-lg border border-zinc-200 mt-6">
      <h3 className="text-lg font-bold mb-4 text-zinc-900">Qrup üzrə Qoşulmalar</h3>
      <div className="space-y-3">
        {Object.entries(connectionStats.by_group).map(([groupId, data]) => {
          // Backend yeni format: {name, total, completed}; köhnə format: number
          const isObj = typeof data === 'object' && data !== null;
          const name = isObj ? (data.name || groupId) : groupId;
          const total = isObj ? (data.total || 0) : data;
          const completed = isObj ? (data.completed || 0) : null;
          return (
            <div key={groupId} className="flex items-center justify-between">
              <span className="text-sm text-zinc-700">{name}</span>
              <span className="font-bold text-zinc-900">
                {total}
                {completed !== null && (
                  <span className="text-xs font-normal text-green-600 ml-2">
                    ({completed} tamamlanıb)
                  </span>
                )}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ConnectionStatsCards;
